<template >
  <div class="ma-2 ml-3 site_content">
    <div class="flex">
      <comboFarm
        @fromFarm="farmInfo"
      />
      <div class="table_header">
        <v-select rounded 
          class="selectedHeaders"
          v-model="selectedHeaders" 
          :items="filteredHeaders" 
          label="조회 지표" 
          density="comfortable"
          item-disabled="disabled"
          color="#005B96"
          :menu-props="{ top: false, offsetY: true }"
          multiple 
          outlined 
          return-object
          dense
          >
          <template v-slot:item="{ active, item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action >
              <v-checkbox :input-value="active" color="#80a087"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title >
                  <div style="color:#005B96;"> {{ item.text }}</div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 4" class="selectChip">
              <span >{{ item.text }}</span>
            </v-chip>
          </template>
        </v-select>
      </div>
    </div>

    <div class="table_content">
      <div class="table">
        <v-data-table class="v-data-table" 
        id="items" 
        ref="items"
        :loading="loading" 
        :headers="showHeaders"
        :items="items"
        :items-per-page= "500"
        no-data-text="등록된 자료가 없거나 접근 권한이 없습니다."
        fixed-header
        hide-default-footer
        sort-by="room_name"
        group-by="building_name"
        show-group-by
        item-key="room_cd"
        mobile-breakpoint="0"
        single-select
        >
        <template v-slot:group.header="{items, isOpen, toggle}">
          <th colspan="14">
            <v-icon @click="toggle">
            {{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon> 
            <span>{{ items[0].building_name }} </span>
          </th>
        </template>

        <template v-slot:item= "{ item }">
          <tr>
            <td v-if="showColumn('room_name')">{{ item.room_name }}</td> 
            <td v-if="showColumn('checkTime')"> <span :class="( item.validTime || item.checkTime == '-') ? '' : 'cell_red text_white'"> {{ item.checkTime }} </span></td>
            <td v-if="showColumn('temp')" >{{ item.temp }}<span :class="(item.temp == '-') ? 'no_unit' : 'unit' "> ℃</span></td>
            <td v-if="showColumn('highestTemp')" class="red-text">{{ item.highestTemp }}</td>
            <td v-if="showColumn('lowestTemp')" class="blue-text">{{ item.lowestTemp }}</td>
            <td v-if="showColumn('feel')" class="text_gray">{{ item.feel }}</td>
            <td v-if="showColumn('hum')">{{ item.hum }}<span :class="(item.hum == '-') ? 'no_unit' : 'unit' "> %</span></td>
            <td v-if="showColumn('co2')">{{ item.co2 }}<span :class="(item.co2 == '-') ? 'no_unit' : 'unit_ppm' "> ppm</span></td>
            <td v-if="showColumn('nh3')">{{ item.nh3 }}<span :class="(item.nh3 == '-') ? 'no_unit' : 'unit_ppm' "> ppm</span></td>
            <td v-if="showColumn('h2s')">{{ item.h2s }}<span :class="(item.h2s == '-') ? 'no_unit' : 'unit_ppm' "> ppm</span></td>
            <!-- <td v-if="showColumn('pig_cnt')">{{ item.pig_cnt }}</td> -->
            <td v-if="(item.services.fancontrol || item.services.esg)  && showColumn('nowVent')" class="fan_info">{{ item.nowVent }}</td>
            <td v-if="(item.services.fancontrol || item.services.esg)  && showColumn('now_temp')">{{ item.now_temp }}</td>

            <td v-if="showColumn('pressure')"> {{ item.w_sensor.pressure }}<span :class="(item.w_sensor.pressure == null) ? 'no_unit' : 'unit' "> hPa </span></td>
            <td v-if="showColumn('speed')"> {{ item.w_sensor.wind.speed }}<span :class="(item.w_sensor.wind.speed == null) ? 'no_unit' : 'unit' "> m/s </span></td>
            <td v-if="showColumn('deg')"> <span v-show="item.w_sensor.wind.deg !== null ">{{ getdirection(item.w_sensor.wind.deg) }}</span> </td>

            <td v-if="showColumn('action')" >
              <button class="link_btn" @click="gotoBarometer(item)">
              <v-icon color="white" size="22" >
                mdi-history 
              </v-icon>
            </button>
            </td>
          </tr>
          </template>
        </v-data-table>
      </div>

      <div class="flex mt-3">
        <v-select dense outlined class="interval_select"
          id="setInterval" 
          ref="setInterval"
          :items="setIntervalItems"
          item-text="descripton"
          return-object
          v-model="setInterval"
          @change="refreshList()"
        />
        <div class="mt-3 ml-2">마다 새로고침</div>
      </div>

    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis'
import VueCookies from "vue-cookies";
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

import comboFarm from "@/components/combo/farm.vue";

var setTime = 0;
var header_list = [];

export default {
  name: 'Summary',
  components:{
    comboFarm,
  },
  data() {
    return {
      items:[],
      farmData: { company: {}, farm: {} },
      loading:false,
      services:{},


      headers: [],
      headersMap: {
        room_name : {text: '구역', value: 'room_name', groupable: false, selected: true , disabled: true},
        checkTime : {text: '측정시간', value: 'checkTime', groupable: false, selected: true, disabled: true },
        temp : {text: '온도', value: 'temp', groupable: false, selected: true, disabled: true },
        highestTemp : {text: '최고', value: 'highestTemp', width: '50px', groupable: false, selected: true },
        lowestTemp : {text: '최저', value: 'lowestTemp', width: '50px', font_size: '5px',groupable: false, selected: true },
        feel : {text: '체감', value: 'feel', width: '70px', groupable: false, selected: true },
        hum : {text: '습도', value: 'hum', groupable: false, selected: true },
        co2 : {text: '이산화탄소', value: 'co2', groupable: false, selected: true },
        nh3 : {text: '암모니아', value: 'nh3', groupable: false, selected: true },
        h2s : {text: '황화수소', value: 'h2s', groupable: false, selected: true },

        //기상센서
        pres : {text: '기압', value: 'pressure', groupable: false, selected: true },
        windspeed : {text: '풍속', value: 'speed', groupable: false, selected: true },
        winddeg : {text: '풍향', value: 'deg', groupable: false, selected: true },

        nowVent : {text: '팬출력', value: 'nowVent', groupable: false, selected: true },
        now_temp : {text: '팬온도', value: 'now_temp', groupable: false, selected: true },
        action : {text: '지표조회', value: 'action', groupable: false, selected: true, disabled: true, sortable:false },
      },
      selectedHeaders: [],

      setInterval: {min: 30, descripton: "30 분"},
      setIntervalItems: [
        { min: 10, descripton: "10 분"},
        { min: 20, descripton: "20 분"},
        { min: 30, descripton: "30 분"},
        { min: 60, descripton: "1 시간"},
      ],

    }
  },
  async created() {
    this.headers = Object.values(this.headersMap);

    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

    let cookie_interval = VueCookies.get("summary_interval");
    if (cookie_interval !== "undefined" && cookie_interval) {
      this.setInterval = cookie_interval;
    } 

  },
  destroyed() {
    clearTimeout(setTime);
    // console.log("clearTimeout",setTime);
  },
  computed:{
  // 1. filteredHeaders - 서비스 조건에 따라 기본적으로 숨겨야 할 헤더만 필터링
    filteredHeaders() {
      return this.headers.filter(header => {
        // 서비스별 쳌박스 헤더 조건 추가
        if (['co2', 'nh3', 'h2s'].includes(header.value)) {
          // items 배열 중 하나라도 유효한 값이 있으면 컬럼 유지
          return this.items.length > 0 && this.items.some(item => item[header.value] !== null && item[header.value] !== '-');
        } else if (['pressure', 'speed', 'deg'].includes(header.value)) {
          return this.items.length > 0 && this.items.some(item => 
            item.w_sensor && 
            (item.w_sensor.pressure !== null && item.w_sensor.pressure !== '-' ||
            item.w_sensor.wind?.speed !== null && item.w_sensor.wind?.speed !== '-' ||
            item.w_sensor.wind?.deg !== null && item.w_sensor.wind?.deg !== '-')
          );
        } else if (header.value === 'nowVent' || header.value === 'now_temp') {
          return this.items.length > 0 && this.items.some(item => 
            item.services && (item.services.fancontrol || item.services.esg) &&
            item[header.value] !== null && item[header.value] !== '' && item[header.value] !== '-'
          );
        }
        return true; // 다른 헤더는 기본적으로 모두 포함
      });
    },

    // 2. showHeaders - selectedHeaders와 서비스 조건을 결합하여 테이블에 표시할 항목 필터링
    showHeaders() {
      let name_list = [];
      this.selectedHeaders.forEach( item => name_list.push(item.value));   // 선택 항목 텍스트 리스트
      let cookie = this.headers.filter(s => name_list.includes(s.value));  // 선택항목 오브젝트 리스트
      localStorage.setItem(this.farmData.farm.code + "_selected_monitoring_summary",JSON.stringify({ list: cookie, name_list: name_list}));  // 농장에대한 선택 쿠키 저장
      header_list = name_list;

      // selectedHeaders에 선택된 항목 + 서비스 조건을 결합하여 필터링
      let selectedValues = this.selectedHeaders.map(item => item.value);
      return this.filteredHeaders.filter(header => selectedValues.includes(header.value));
    }

  },

  methods:{
    showColumn(col){
      if (['co2', 'nh3', 'h2s'].includes(col)) {
        return this.selectedHeaders.find(s => s.value === col) && 
              this.items.length > 0 && 
              this.items.some(item => item[col] !== null && item[col] !== '-');
      } else if (['pressure', 'speed', 'deg'].includes(col)) {
        return this.selectedHeaders.find(s => s.value === col) && 
              this.items.length > 0 && 
              this.items.some(item => 
                item.w_sensor && 
                (item.w_sensor.pressure !== null && item.w_sensor.pressure !== '-' ||
                  item.w_sensor.wind?.speed !== null && item.w_sensor.wind?.speed !== '-' ||
                  item.w_sensor.wind?.deg !== null && item.w_sensor.wind?.deg !== '-')
              );
      } else if (col === 'nowVent' || col === 'now_temp') {
        return this.selectedHeaders.find(s => s.value === col) && 
              this.items.length > 0 && 
              this.items.some(item => 
                item.services && (item.services.fancontrol || item.services.esg) &&
                item[col] !== null && item[col] !== '' && item[col] !== '-'
              );
      }
      return this.selectedHeaders.find(s => s.value === col);
      
    },
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      clearTimeout(setTime);
      this.refreshList();
    },
    refreshList(){
      let cookie = JSON.parse(localStorage.getItem( this.farmData.farm.code + "_selected_monitoring_summary"));  // 쿠키에 저장된 농장 선택 해드리스트 
      if (cookie && cookie.list.length > 0) {
        this.selectedHeaders = cookie.list;
        header_list = cookie.name_list;
        }
      else { // 없으면 초기화
        this.selectedHeaders = this.headers;
        this.selectedHeaders.forEach( item => header_list.push(item.value));
      }
      if (this.msgFlag) this.$store.commit("resMessage","");
      if (!this.farmData.farm || !this.farmData.farm.code ) {
        alert("농장을 선택하세요");
        return;
      }
      this.loading = true;

      Apis.monitoringSummary({
        farm_cd: this.farmData.farm && this.farmData.farm.code || "",
        building_cd: "",
        stand_dt: dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss"), 
        // check_list : ["temp","hum","feel"],
      } ,(res) => {  // 정상처리
        this.items = res.data;
        // console.log(this.items)
        if (this.msgFlag) this.$store.commit("resMessage",res.message);
        this.loading = false;

        let cookie_interval = this.setInterval;
        VueCookies.set("summary_interval" ,cookie_interval,"30d");
        this.$route.path == "/summary" ? setTime = setTimeout( () =>  this.refreshList(), this.setInterval.min * 60 * 1000) : "" ;
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("monitoringSummary 호출 오류",err);
        // alert("monitoringSummary 호출 오류" + err);
        this.$router.push("/");
        this.loading = false;
      })
    },
    gotoBarometer(item) {
      sessionStorage.setItem("summaryData",JSON.stringify(this.items));
      // alert('수정중입니다.')
      this.$router.push({
        name: "Barometer",
        params: { 
          company: {code: this.farmData.farm.company_cd, name: this.farmData.farm.company_name},
          farm: {code: this.farmData.farm.code, name: this.farmData.farm.name, biz:this.farmData.farm.biz},
          building: {code: item.building_cd, name: item.building_name},
          room: {code: item.room_cd, name: item.room_name + " " + item.farm_name},
          }
      });
    },
    getdirection(item){
      return Common.getDirection(item);
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
@import '../../style/dataTable.scss';
.v-list .v-list-item--link:before{
  opacity: 0;
}
.v-list-item--disabled{
  display:none !important;
}
.table_header{
  margin-top:5px;
  margin-left:30px;
}
.v-data-table::v-deep{
  .v-data-table__wrapper {
    thead{
      th{
        color:rgb(73, 73, 73) !important;
      }     
    }
  }
}
::v-deep .selectedHeaders .v-input__slot{
  min-width: 345px !important;
  max-width: 345px !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 25px !important;
}
::v-deep .selectedHeaders .v-select__slot{
  min-width:300px !important; 
}
.table_content{
  margin-top:20px;
  // max-height: 80vh !important;
}

.table{
  border:1px solid #D5D5D5;
  border-radius: 5px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.interval_select{
  min-width:150px;
  max-width:150px;
}
::v-deep .interval_select .v-input__slot{
  box-shadow: none !important;
  border:1px solid $darkgray-color !important;
}
.link_btn{
  width:50px !important;
  height:30px !important;
  border-radius: 20px !important;
  background-color: $point-color;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
}
.red-text , .blue-text{
  font-size:15px !important;
}
.unit , .no_unit{
  font-size:12px;
}
.no_unit{
  display:none;
}
.unit_ppm{
  font-size:11px;
}
</style>